import Modal from 'developer_components/newModal';
import ModalDialog from 'components/modal-dialog.dev';
import Select from 'components/select';
import PhotogalleryUploader from 'components/photogallery-uploader';
import {isMobile} from 'methods/utils';
import RecallPhotogallery from './recall-photogallery';
import RecallPhotogalleryMobile from './mob/recall-photogallery';

/**
 * Модалка отзывов на странице объекта
 */
function HotelRecalls() {
    this._$review            = document.getElementById('Review');
    this._$openRecallModal   = document.querySelector('.js-openRecallModal');
    this._$showMoreReviews   = document.querySelector('.js-showMoreReviews');
    this._$recallList        = document.querySelector('.js-recallList');
    this._isLoading          = false;
    this._recallPhotogallery = isMobile()
        ? new RecallPhotogalleryMobile()
        : new RecallPhotogallery();

    // клик по кнопке добавления отзыва
    if (this._$openRecallModal) {
        this._$openRecallModal.addEventListener('click', () => {
            this._openRecallModal();
        });
    }

    // клик по кнопке показать еще отзывы
    if (this._$showMoreReviews) {
        this._$showMoreReviews.addEventListener('click', this._loadMoreRecalls.bind(this));
    }
}

/**
 * Подугружаем еще отзывы
 */
HotelRecalls.prototype._loadMoreRecalls = function() {
    if (!this._$recallList || !this._$showMoreReviews || this._$showMoreReviews.classList.contains('loading')) {
        return;
    }

    this._$showMoreReviews.classList.add('loading');

    let formData = new FormData();
        formData.append('hotel_id', document.querySelector('.js-hotelData').dataset.hotel_id);
    this._$recallList.querySelectorAll('.js-recallList > .js-item').forEach($item => formData.append('exclude_recall_ids[]', $item.dataset.id));

    fetch(`${location.pathname}get_more_recalls/`, {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => setTimeout(() => {
        if (r.status === 'ok') {
            this._$recallList.insertAdjacentHTML('beforeend', r.render);

            this._recallPhotogallery.update();
        }

        if (this._$recallList.querySelectorAll('.js-item').length >= this._$review.dataset.count) {
            this._$showMoreReviews.remove();
        }

        this._$showMoreReviews.classList.remove('loading')
    } , 500));

}

/**
 * Открываем модалку отзывов
 */
HotelRecalls.prototype._openRecallModal = function() {
    if (!this._$modal) {
        return this._loadRecallModal();
    }

    this._modal.open();
}

/**
 * Загружаем модалку отзывов
 */
HotelRecalls.prototype._loadRecallModal = function() {
    if (this._$modal) {
        return this._openRecallModal();
    }

    // загрузка модалки
    if (this._isLoading) {
        return false;
    }
    this._isLoading = true;

    // инициализация модалки
    this._$modal = document.getElementById('hotel-recall-modal');
    this._modal  = new Modal(this._$modal, {
        disableClose: true
    });

    // инициализация события и полей
    this._initSelects();
    this._initStars();
    this._initFormSubmit();

    this._photogalleryUploader = new PhotogalleryUploader(this._$modal.querySelector('.js-photogalleryUploader'));

    // открываем модалку
    this._openRecallModal();
}

/**
 * Инициализация Select выбора месяца и года
 */
HotelRecalls.prototype._initSelects = function() {
    // инициализируем select
    let monthRecalc = (value) => {
        // если выбран текущий год, то убираем будущие месяца
        if (value == (new Date()).getFullYear()) {
            let currentMonth = (new Date()).getMonth() + 1;

            // выбираем первый месяц
            month.setSelectedIndex(0);

            month.getItems().forEach($item => {
                if (currentMonth < $item.dataset.value) {
                    $item.style.display = 'none';
                }
            });
        } else {
            month.getItems().forEach($item => {
                $item.style.display = '';
            });
        }
    }

    let month = new Select(this._$modal.querySelector('.Select[data-name="month"]'));
    let year  = new Select(this._$modal.querySelector('.Select[data-name="year"]'), {
        on: {
            ready: monthRecalc,
            change: monthRecalc,
        },
    });
}

/**
 * Инициализация звезд
 */
HotelRecalls.prototype._initStars = function() {
    // наведение на звезды
    let $starContainer = this._$modal.querySelector('.js-stars');
    let $stars         = $starContainer.querySelectorAll('.js-stars .star');
    let $input         = $starContainer.querySelector('[name="rating"]');

    const selectStars = (count) => {
        $stars.forEach($item => {
            $item.style.backgroundImage = 'url(/app/src/img/svg/review_unactive_star.svg)';
            $item.classList.toggle('is-active', count >= $item.dataset.id);

            if (count >= $item.dataset.id) {
                $item.style.backgroundImage = 'url(/app/src/img/svg/review_active_star.svg)';
            }
        });
    }

    $stars.forEach($star => {
        $star.addEventListener('mouseenter', (e) => {
            selectStars($star.dataset.id);
        });

        // выбор звезд
        $star.addEventListener('click', (e) => {
            if ($input.value == $star.dataset.id) {
                $input.value = 0;
            } else {
                $input.value = $star.dataset.id;
            }

            selectStars($input.value);
        });
    });

    $starContainer.addEventListener('mouseleave', (e) => {
        selectStars($input.value);
    });

    selectStars(0);
}

HotelRecalls.prototype._initFormSubmit = function() {
    this._$form = this._$modal.querySelector('.js-form');
    this._$form.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (this._$form.classList.contains('is-sending')) {
            return false;
        }
        this._$form.classList.add('is-sending');

        let $error  = e.target.querySelector('.js-error');
        let $fields = e.target.querySelectorAll('.input, .Select, .comment');

        fetch('/hotels_recalls/save/', {
            method: 'POST',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: new FormData(e.target),
        })
        .then(response => response.json())
        .then(r => {
            $fields.forEach($field => $field.classList.remove('has-error'));
            $error.classList.remove('is-active');

            if (r.status == 'error') {
                this._$form.classList.remove('is-sending');

                if (r.error_fields) {
                    $fields.forEach($field => {
                        let name = $field.getAttribute('name') || $field.dataset.name;
                        if (r.error_fields.includes(name)) {
                            $field.classList.add('has-error');
                        }
                    });
                }

                if (r.message) {
                    $error.classList.add('is-active');
                    $error.textContent = r.message;
                }
            } else {
                new ModalDialog({
                    header: 'Спасибо!',
                    message: 'Ваш отзыв добавлен и после модерации будет опубликован.',
                    autoClose: false,
                    setSession: true
                });

                location.reload();
            }
        });
    });
}

export default HotelRecalls;
